import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';  // Load after App to avoid overriding styles.css

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`).catch(() => {
      /* installable PWA is optional */
    });
  });
}